import { ChevronLeft, ChevronRight } from "lucide-react";

const NavigationButton = ({ direction, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="p-2 rounded-full bg-white shadow-md hover:bg-green-50 transition-all duration-200 text-green-600 hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
  >
    {direction === "prev" ? (
      <ChevronLeft className="w-6 h-6" />
    ) : (
      <ChevronRight className="w-6 h-6" />
    )}
  </button>
);

export default NavigationButton;
